var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"tile":""}},[_c('v-img',{staticClass:"white--text",attrs:{"src":this.picture,"height":"150px","gradient":"rgba(0,0,0, 0.5), rgba(0,0,0,0.2)"}},[_c('v-card-title',[_c('h3',[_vm._v(" "+_vm._s(_vm.title)+" ")])])],1),_c('v-card-actions',[_vm._t("actions")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }